import { MaterialModule } from 'src/app/core/shared/util/material/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityCardBasicComponent } from './entity-card-basic.component';
import { ImageViewModule } from 'src/app/features/images/components/image-view/image-view.module';

@NgModule({
  declarations: [EntityCardBasicComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ImageViewModule
  ],
  exports: [EntityCardBasicComponent]
})
export class EntityCardBasicModule { }
